import { MessageCircle } from "lucide-react";
import { brand } from "@/mock";

export const WhatsAppButton = () => {
  const waLink = `https://wa.me/${brand.whatsapp}?text=${encodeURIComponent(
    "Përshëndetje, kam nevojë për asistencë për një shërbim funebër."
  )}`;
  return (
    <a
      data-testid="floating-whatsapp-btn"
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Na kontaktoni në WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center h-14 w-14 rounded-full bg-[#128C4B] text-white shadow-lg shadow-black/40 hover:bg-[#0f7a41] hover:scale-105 transition-transform duration-300"
    >
      <MessageCircle size={26} strokeWidth={1.5} />
    </a>
  );
};
